/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { addNonBreakingSpaces, cleanExternalLinks } from '../../lib/utils';

import styles from '../../../styles/blocks/text.scss';

const propTypes = {
    text: PropTypes.string,
    isLast: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    text: null,
    isLast: false,
    className: null,
};

const TextBlock = ({ text, isLast, className }) => {
    const body = cleanExternalLinks(addNonBreakingSpaces(text));
    // console.log(body);
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.isLast]: isLast,
                [className]: className !== null,
            })}
            dangerouslySetInnerHTML={{ __html: body }}
        />
    );
};

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;

export default TextBlock;
